export default function LoadingDots() {
  return (
    <span className="flex items-center gap-1">
      <span className="w-1.5 h-1.5 rounded-full bg-white/40 animate-pulse [animation-delay:0ms]" />
      <span className="w-1.5 h-1.5 rounded-full bg-white/40 animate-pulse [animation-delay:300ms]" />
      <span className="w-1.5 h-1.5 rounded-full bg-white/40 animate-pulse [animation-delay:600ms]" />
    </span>
  )
}
